import React from 'react';
import clsx from 'clsx';

// @material-ui
import { Box, Icon, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import { withLang } from '_core/hocs/withLang';

// style
import { cardTitleStyle } from './cardTitleStyle';

const RawCardTitle = props => {
  const {
    classes,
    className,
    // unmargin,
    // marginNone,
    // iconMarginNone,
    children,
    icon,
    title,
    getLangString: l
  } = props;

  const titleClasses = clsx({
    [classes.container]: true,
    // [classes.unmargin]: unmargin,
    // [classes.marginNone]: marginNone,
    // [classes.iconMarginNone]: iconMarginNone,
    [className]: className !== undefined
  });

  if (icon == null && title == null)
    return null;

  return (
    <Box display="flex" alignItems="center" className={titleClasses}>
      {icon != null ? <Icon className={classes.icon}>{icon}</Icon> : null}

      {children != null ? children : null}

      {title != null ? (
        <Typography variant="h5" component="h2">
          {(typeof(title) === 'string' || title instanceof String) && title.startsWith('$') ? l(title.substring(1)) : title}
        </Typography>
      ) : null}
    </Box>
  )
};

export default withLang(withStyles(cardTitleStyle)(RawCardTitle));
